<template>
    <div id="viewResult">
        <my-header></my-header>
        <div class="banner">
            <!--<img src="../../../assets/images/invitemanage/banner01.png"/>-->
            <img src="../../../assets/images/invitemanage/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>查看询标报价</span></h2>
                    <!--<p>发布时间：{{ endTime }}</p>-->
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <el-tabs v-model="activeName" >
                <el-tab-pane v-for="(item,index) in bidPriceForSections" :label="item.sectionName" :name="''+index" :key="index" class="stepTab">
                    <section class="small-container">
                        <h2>
                            <img src="../../../assets/images/invitemanage/price2.png"/>
                        </h2>
                        <el-table
                            :data="item.bidPriceForSectionVOs"
                            tooltip-effect="light"
                            style="width: 100%">
                            <el-table-column
                                width="260"
                                label="供方名称">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName != 'hide'">{{ scope.row.supplierName  }}</span>
                                    <span v-else><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="260"
                                :show-overflow-tooltip="true"
                                label="询标报价(含税,元)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName == 'hide' && scope.row.isShowInquiryPrice == 1"><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                    <span v-else>{{ scope.row.inquiryPriceTax && $root.toThousands(scope.row.inquiryPriceTax)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="260"
                                label="询标报价（不含税,元）">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName == 'hide' && scope.row.isShowInquiryPrice == 1"><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                    <span v-else>{{ scope.row.inquiryPriceNotax && $root.toThousands(scope.row.inquiryPriceNotax)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="260"
                                label="询标报价(税额,元)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName == 'hide' && scope.row.isShowInquiryPrice == 1"><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                    <span v-else>{{ scope.row.inquiryTaxPrice && $root.toThousands(scope.row.inquiryTaxPrice)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>
                    <!--<section class="small-container">
                        <h2 class="thanks">
                            <img src="../../../assets/images/invitemanage/price1.png"/>
                        </h2>
                        <el-table
                            :data="item.bidPriceForSectionVOs"
                            tooltip-effect="light"
                            style="width: 100%">
                            <el-table-column
                                width="260"
                                label="供方名称">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName != 'hide'">{{ scope.row.supplierName  }}</span>
                                    <span v-else><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="260"
                                :show-overflow-tooltip="true"
                                label="回标报价(含税,元)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName == 'hide' && scope.row.isShowReturn == 1"><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                    <span v-else>{{ scope.row.returnPriceTax && $root.toThousands(scope.row.returnPriceTax)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="260"
                                label="回标报价（不含税,元）">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName == 'hide' && scope.row.isShowReturn == 1"><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                    <span v-else>{{ scope.row.returnPriceNotax && $root.toThousands(scope.row.returnPriceNotax)}}</span>
                                </template>

                            </el-table-column>
                            <el-table-column
                                width="260"
                                label="回标报价(税额,元)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.supplierName == 'hide' && scope.row.isShowReturn == 1"><img style="width:20px;height:26.7px;" src="../../../assets/images/invitemanage/icon003.png"/></span>
                                    <span v-else>{{ scope.row.returnTaxPrice && $root.toThousands(scope.row.returnTaxPrice)}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>-->
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../MasterHeader.vue';
    export default {
        name: 'viewResult',
        data() {
            return {
                projectName: '',//项目名称
                bidPriceForSections: [],//有几个标段
                activeName: '0',//el-tab-pane 的activename
                endTime:'',//发布时间
            }
        },
        components: {MyHeader},
        created(){
            this.$root.activeIndex = 'win';
            this.getData();//初始化数据
        },
        methods: {
            getData(){
                this.$root.postHttp('/v1/outerformflow/bidOpenPrice/list',{
                    bidSchemeId: this.$route.params.formId
                }, (res) => {
                    this.bidPriceForSections = res.data.data.bidPriceForSections;
                    this.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
                })
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#viewResult {
    padding: 80px 0 50px;
    min-height: 85vh;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        img {
            width: 100%;
            min-width:1300px;
            height: 140px;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        background: #fff;
    }
    .el-tabs {
        background: #fff;
        /*padding-top: 20px;*/
        & .el-tabs__header {
            margin: 0 0 10px;
        }
        & .el-tabs__nav {
            margin-left: 40px;
        }
        & .el-tabs__item {
            font-size: 14px;
            height: 50px;
        }
        & .el-tabs__item.is-active {
            color: $--text-color;
            font-weight: 700;
        }
        & .el-tabs__active-bar {
            bottom: -2px;
            height: 12px;
            background: url('../../../assets/images/register/at.png') no-repeat center 0;
        }
        & .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: $--secondary-fill-color;
        }
    }
    .small-container {
        margin: 15px auto 0;
        padding: 30px 80px 60px;
        background: #fff;
        h2 {
            margin-top: 20px;
            overflow: hidden;
            text-align: left;
            img {
                float: left;
                width: 300px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 6px 10px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 3px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/backStandard/icon01.png') no-repeat;
                }
            }
        }
        .el-table{
            margin-top: 20px;
            th {
              text-align: center;
            }
            & .words {
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
        .el-pagination{
            margin: 60px 0 30px;
            text-align: right;
            .el-pagination__total {
                float: left;
            }
            .btn-prev,
            .btn-next {
                padding: 0 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ViewResult.vue